module.exports = __webpack_public_path__ + "static/logo-e8d4d1aa011eaf6286db35a81c713eeb.jpg";